import { render, staticRenderFns } from "./PresentationEditorWrapper.vue?vue&type=template&id=5207f36c&scoped=true&"
import script from "./PresentationEditorWrapper.vue?vue&type=script&lang=js&"
export * from "./PresentationEditorWrapper.vue?vue&type=script&lang=js&"
import style0 from "./PresentationEditorWrapper.vue?vue&type=style&index=0&id=5207f36c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5207f36c",
  null
  
)

export default component.exports